<template>
<!-- The mobile home contains the KeywordSearch, TreeView and DetailPane components with no modal -->
  <section>
    <div class="columns">
      <div class="column is-full">
        <div v-if="error" class="error">
          <open-services-errors-component
            :lang="this.mx_toggleLang"
            @closed="error = null"
          ></open-services-errors-component>
        </div>
        <div class="mobileSelectVals">
          <span v-if="this.selectValues.length <= 1">
            <b-tag rounded class="is-info is-small" :class="this.selectValues.length == 0 ? 'is-grey' : ''" v-html="this.selectValues.length"></b-tag>&nbsp;
            <span>{{ $tc('industry_selection', 1) }}</span>
          </span>
          <span v-if="this.selectValues.length > 1">
            <b-tag rounded class="is-info is-small" v-html="this.selectValues.length"></b-tag>&nbsp;
            <span>{{ $tc('industry_selection', 2) }}</span>
          </span>
          <span v-if="this.getAllCheckedValues.naics.length != 0">
            <br /><span class="mobileSelectLinkFix">&nbsp;(<a class="clear-button" @click="clear()">{{ $t('clear') }}</a>)</span>
          </span>
        </div>
        <KeywordSearch
          :lang="this.mx_toggleLang"
          :bpdata_selectionid="this.getAllSavedValues"
          :clearkeyword="this.clearedkeyword"
          @update="updateTree"
          @errored="getError"
        ></KeywordSearch>
      </div>
    </div>
    <br/>
    <div v-if="this.displayTree" class="mobile-format">
      <tiny-slider
        :mouse-drag="false"
        speed="300"
        mode="carousel"
        :arrow-keys="true"
        :auto-height="true"
        :touch="false"
        :loop="false"
        :nav="false"
        :controls="false"
        :controlsText="[$t('tree'), $t('detail')]"
        items="1"
        gutter="0"
        ref="tinySlider"
      >
        <div class="divscroll">
          <div class="scrollpane">
            <TreeView
              :lang="this.mx_toggleLang"
              :multiple="this.mx_toggleMultiple"
              :bpdata_newtreedata="this.getTreeData"
              :bpdata_itemselected="this.getAllCheckedValues.naics"
              :showCode="this.showCode"
              :bpdata_clearall="this.clearAll"
              :iduncheck="this.iduncheck"
              :bpdata_this="this"
              @bpdata_selection="mx_treeSelection"
              @getDetail="detailId"
              @cleared="treeCleared"
              @save="saveSelection"
            ></TreeView>
          </div>
        </div>
        <div>
          <DetailPane
            :lang="this.mx_toggleLang"
            :multiple="this.mx_toggleMultiple"
            :bpdata_id="this.detailID"
            :bpdata_this="this"
            @errored="getError"
            @uncheckedid="uncheckedid"
          ></DetailPane>
        </div>
      </tiny-slider>
    </div>
    <div class="footer-mobile">
      <hr />
      <div class="mobile-bottom">
        <span class="source-footer-mobile">
          <a @click="goToDefaultDetail()">{{ $t('source') }}</a>
        </span>
        <span class="faq-footer-mobile">
          <a :href="this.FAQLink" target="_blank" :title="$t('faq')" @click="GAHandler"><abbr :title="$t('faq')">{{ $t('faqAbbr') }}</abbr></a>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import TreeView from "./TreeView.vue";
import VueTinySlider from "vue-tiny-slider";
import KeywordSearch from "./KeywordSearch.vue";
import DetailPane from "./DetailPane.vue";
import OpenServicesErrorsComponent from "@bizpal/open-services-errors-component";
import 'tiny-slider/src/tiny-slider.scss';

export default {
  name: "MobileHome",
  i18n: {
    locale: "en",
    messages: {
      en: {
        cancel_button: "Cancel",
        save_label: "Select an industry to continue | Select at least one result to continue",
        save_text: "Save",
        no_option: "Sorry, no matching option",
        no_result: "No industries found...",
        industry_selection: "selection | selections",
        label: "Select your industry | Select your industries",
        clear: "Clear",
        edit_button: "Edit",
        reset_button: "Reset",
        tree: "Tree",
        detail: "Detail",
        info_text: "Detail shows information of the selected or checked NAICS",
        selection: "selection:",
        faq: "Frequently Asked Questions",
        faqAbbr: "FAQ",
        source: "Source"
      },
      fr: {
        cancel_button: "Annuler",
        save_label: "Choisissez une industrie pour continuer | Choisissez au moins une industrie pour continuer",
        save_text: "Sauvegarder",
        no_option: "Désolé, aucunes options correspondantes.",
        no_result: "Aucunes industries trouvées...",
        industry_selection: "sélection | sélections",
        label: "Trouvez votre industrie | Trouvez vos industries",
        clear: "Effacer",
        edit_button: "Éditer",
        reset_button: "Réinitialiser",
        tree: "Arbre",
        detail: "Détail",
        info_text: "Les informations du SCIAN sélectionné ou coché sont montrés avec Détail",
        selection: "sélection :",
        faq: "Foire aux questions",
        faqAbbr: "FAQ",
        source: "Source"
      }
    }
  }, // end i18n
  props: {
    lang: {
      type: String,
      default: "en"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    resultstree: {
      type: Array,
      default: function() { return [] }
    },
    showCode: {
      type: Boolean,
      default: true
    }
  }, // end props
  data: function() {
    return {
      FAQLink: process.env.VUE_APP_FAQ,
      treeNodes: this.getResultsTree,
      searchTerm: this.getSearchKeyword,
      detailID: "",
      uncheckdetailid: "",
      iduncheck: "",
      uncheck: false,
      showDetail: false,
      selectDetailValues: [],
      selectTree: [],
      savedValues: {},
      error: null,
      examplesByNaics: {},
      clearAll: false,
      clearedkeyword: false,
      clearResult: false,
      displayTree: true
    };
  }, // end data
  components: { TreeView, DetailPane, KeywordSearch, OpenServicesErrorsComponent, 'tiny-slider': VueTinySlider },
  mounted: function() {
    this.$i18n.locale = this.mx_toggleLang;
    if (this.getResultsTree.length != 0) {
      this.treeNodes = this.getResultsTree;
    }
    this.updateHasResults(false);
    this.searchTerm = this.getSearchKeyword;
  }, // end mounted
  computed: {
    toggleResults: function() {
      return this.showResults;
    },
    toggleMultiple: function() {
      return this.multiple;
    },
    getTreeData: function() {
      return this.getReducedTree;
    },
    getResultsTree: function() {
      return this.clearResults ? [] : this.resultstree;
    },
    selectValues: function() {
      return this.getAllCheckedValues.naics;
    },
    toggleTerm: function() {
      return this.getSearchKeyword;
    }
  }, // end computed
  watch: {
    selectValues: function() {
      this.selectDetailValues = this.selectValues;
    }, // end selectValues
    toggleTerm: function() {
      if (this.toggleTerm.length != 0) {
        this.displayTree = true;
      } else {
        if (this.getAllCheckedValues.naics.length == 0) {
          if (!this.mx_isMobile()) {
            this.displayTree = false;
          } else {
            this.updateReducedTree(this.getInitTree)
          }
        }
      }
      if (this.mx_isMobile() && this.toggleTerm.length == 0) {
        this.updateReducedTree(this.getInitTree);
      } 
    }, // end toggleTerm
    lang: function() {
      this.$i18n.locale = this.mx_toggleLang;
    } // end lang
  }, // end watch
  methods: {
    goToDefaultDetail: function() {
      this.detailID = "";
      this.$refs.tinySlider.slider.goTo(2);
    }, // end goToDefaultDetail
    clear: function() {    
      this.$gtag.event("industries-clear-all", {
        event_category: "naics-tree-widget",
        event_label: "user clear all industries selection",
        product: process.env.VUE_APP_PRODUCT
      });
      this.clearAll = true;
      this.uncheck = true;
      this.updateAllChecked({
        key: "naics",
        payload: []
      });
    }, // end clear
    treeCleared: function() {
      this.clearAll = false;
    }, // end treeCleared
    detailCleared: function() {
      this.clearAll = false;
    }, // end detailCleared
    updateTree: function(event) {
      this.updateReducedTree(event);
    }, // end updateTree
    treeValues: function(event) {
      this.updateAllSaved({
        key: "naics",
        payload: event
      });
    }, // end treeValues
    treeSelect: function(event) {
      this.selectTree = event;
    }, // end treeSelect
    detailId: function(event) {
      this.detailID = event;
      // goto detail slide when selection was made in the tree
      this.$refs.tinySlider.slider.goTo(2);
    }, // end detailId
    hasDetail: function(event) {
      this.showDetail = event;
    }, // end hasDetail
    getError: function(event) {
      this.error = event;
    }, // end getError
    updateExamples: function(event) {
      this.examplesByNaics = event;
    }, // end updateExamples
    uncheckid: function(event) {
      this.detailID = event;
      this.uncheckdetailid = event;
      this.uncheck = true;
      this.$refs.tinySlider.slider.goTo(2);
    }, // end uncheckid
    uncheckedid: function(event) {
      this.iduncheck = event;
    }, // end uncheckedid
    saveSelection: function(value) {
      this.$emit("save", value);
    }, // end saveSelection
    GAHandler: function() {      
      this.$gtag.event("FAQ-clicked", {
        event_category: "naics-tree-widget",
        event_label: "user clicked on FAQ link",
        product: process.env.VUE_APP_PRODUCT
      });      
    } // end GAHandler    
  } // end methods
}; // end export default
</script>

<style>
@media only screen and (max-width: 767px) {
  .open-services-tree-naics-lookup .clear-button {
    background-color: transparent;
    color: #000;
    text-decoration: underline;
  }
}
.open-services-tree-naics-lookup .divscroll {
  height: 78vh ;
  overflow: auto;
  position: relative;
}
.open-services-tree-naics-lookup .scrollpane {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 20px;
  position: relative;
  z-index: 10000;
}
.open-services-tree-naics-lookup .hiddenText {
  display: none;
}
.open-services-tree-naics-lookup .tree-checkbox.checked:after {
  left: 4.5px;
  top: -0.05px;
  height: 12px;
  width: 6px;
}
.open-services-tree-naics-lookup .collapse > .collapse-trigger {
  position: absolute;
}
/* For Detail pane checkbox formatting */
.open-services-tree-naics-lookup .b-checkbox.checkbox input[type=checkbox] + .check {
  border: 1px solid #218eff;
}
.open-services-tree-naics-lookup .b-radio.radio input[type=radio] + .check {
  border: 1px solid #218eff;
}
.open-services-tree-naics-lookup .display-as-radio-button .b-radio.radio {
  margin-left: 5px;
  margin-top: 5px;
  border-radius: 20px !important;
  border: 1px solid #218eff;
  width: 20px;
  height: 20px;
}
.open-services-tree-naics-lookup .display-as-radio-button .b-radio.radio input[type=radio] + .check {
  margin-left: 3px;
  margin-top: 0px;
  background-color: #eee;
  border: none !important;
  width: 12px;
  height: 12px;
}
.open-services-tree-naics-lookup .display-as-radio-button .b-radio.radio input[type=radio] + .check:before {
  background-color: #218eff;
}
.open-services-tree-naics-lookup .display-as-radio-button .b-radio.radio input[type=radio]:checked + .check:before {
  transform: scale(0.65);
}
.open-services-tree-naics-lookup .display-as-radio-button .b-radio.radio input[type="radio"]:checked + .check {
  background-color: #218eff;
  background-image: none;
  margin-left: 3px;
  margin-bottom: 1px;
  width: 12px;
  height: 12px;
}
.open-services-tree-naics-lookup .mobileSelectVals {
  position: relative;
  float: right;
  top: 12px;
  right: 20px;
  font-size: 0.85em;
}
.open-services-tree-naics-lookup .mobileSelectVals > span > span, .open-services-tree-naics-lookup .mobileSelectVals > span > .mobileSelectLinkFix {
  top: 5px;
  position: relative;
}
.open-services-tree-naics-lookup .mobileSelectLinkFix {
  text-align: right;
  float: right;
  margin-top: 0px;
  margin-bottom: 10px;
}
.open-services-tree-naics-lookup .is-grey {
  background-color: #99968E !important;
}
.open-services-tree-naics-lookup .mobile-format {
  clear: both;
  margin-left: 15px;
}
.open-services-tree-naics-lookup hr {
  margin-bottom: 5px;
  background-color: #38598a;
}
@media (max-width: 767px) {
  .open-services-tree-naics-lookup .footer-mobile {
    background-color: #fff;
    padding-bottom: 10px;
  }
  .open-services-tree-naics-lookup .mobile-bottom {
    display: flex;
    justify-content: space-between;
  }
  .open-services-tree-naics-lookup .source-footer-mobile  {
    text-align: left;
    margin-left: 5px;
  }
  .open-services-tree-naics-lookup .source-footer-mobile > a {
    color: #38598a;
  }
  .open-services-tree-naics-lookup .faq-footer-mobile  {
    text-align: right;
    padding-right: 2px;
  }
  .open-services-tree-naics-lookup .faq-footer-mobile > a {
    color: #38598a;
  }
  /* For mobile only - solution to use abbr on mobile */
  abbr[title]:after {
    content: " (" attr(title) ")";
  }
}
</style>
